import React from 'react';
import { useTranslation } from 'react-utilities';
import { TBadUtterance } from '../utils/types';

export type Props = {
  badUtterance: TBadUtterance;
};

const NotApprovedBadUtterance = ({ badUtterance }: Props): JSX.Element => {
  const { translate } = useTranslation();

  return (
    <div className='not-approved-punishment-details-item'>
      <p className='not-approved-punishment-details-item-row'>
        {/* eslint-disable-next-line react/jsx-no-literals */}
        {translate('Label.Reason')}:{' '}
        <strong>
          {translate(badUtterance.labelTranslationKey) ?? translate('Label.AbuseType.Other')}
        </strong>
      </p>
      <p className='not-approved-punishment-details-item-row'>
        {/* eslint-disable-next-line react/jsx-no-literals */}
        {translate('Label.OffensiveItem')}: <strong>{badUtterance.utteranceText}</strong>
      </p>
    </div>
  );
};

export default NotApprovedBadUtterance;
